import PropTypes from 'prop-types';
import { Typography } from '@okta/odyssey-react-mui';
import { useTranslation } from 'react-i18next';

const Expiry = ({ expiry }) => {
  const { t } = useTranslation();
  const diffMs = new Date(expiry).getTime() - new Date().getTime();
  const days = Math.max(Math.ceil(diffMs / (1000 * 60 * 60 * 24)), 0);

  return (
    <Typography variant="subordinate" color="error">
      {t('labCard-remainingCount', { count: days })}
    </Typography>
  );
};

Expiry.propTypes = {
  expiry: PropTypes.string.isRequired,
};

export default Expiry;